<ng-container>
  <div mat-dialog-title>
    <span>
      <ng-container *ngIf="!(loading$ | async); else titleSpinner">
        {{ title | translate: {name: customView.name} }}
      </ng-container>
      <ng-template #titleSpinner>
        <app-title-spinner></app-title-spinner>
      </ng-template>
    </span>

    <q9-dialog-close-button></q9-dialog-close-button>
  </div>

  <q9-content-loader [isLoading]="loading$ | async"></q9-content-loader>

  <ng-container *ngIf="!(loading$ | async)">
    <div class="edit-custom-view-filters-dialog">
      <ng-container>
        <app-add-filters-view
          [mode]="'editing'"
          [view]="customView"
          [closeBtn]="'POPUPS.CANCEL'"
          (submitForm)="submit($event)"
          (cancelFiltersSelect)="closeModal()"></app-add-filters-view>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
